export function getStorage(type: "localStorage" | "sessionStorage") {
  return window[type];
}
